import { render, staticRenderFns } from "./TqDisplayFile.vue?vue&type=template&id=247a65aa&scoped=true&"
import script from "./TqDisplayFile.vue?vue&type=script&lang=js&"
export * from "./TqDisplayFile.vue?vue&type=script&lang=js&"
import style0 from "./TqDisplayFile.vue?vue&type=style&index=0&id=247a65aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a65aa",
  null
  
)

export default component.exports